<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>{{ title }}</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row v-if="searchForm.syncDataSource == null">
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" :options="listSyncSourceTypes"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" :syncSourceType="unitSyncSourceType" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị đồng bộ:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-unit-type v-model="searchForm.syncUnitType"></sync-unit-type>
                                </b-form-group>
                                <b-form-group label="Phần mềm đồng bộ:" v-if="searchForm.syncDataSource == 1"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" :options="listSyncSourceTypes"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Nhóm tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<treeselect v-model="searchForm.assetTypeGroupId" v-if="!showAssetType"
                                    placeholder="--- Tất cả ---"
                                    :options="listAssetTypeGroups" />-->
                                    <select2 v-if="!showAssetType" :options="listAssetTypeGroups"
                                             v-model="searchForm.assetTypeGroupId"
                                             placeholder="--- Tất cả ---"
                                             :allowClear="true"> </select2>
                                    <treeselect v-model="searchForm.assetTypeGroupId" v-if="showAssetType"
                                                placeholder="--- Tất cả ---"
                                                :options="listAssetTypes" />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Tên tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.name" placeholder="Nhập tên ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mã tài sản tại kho:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.code" placeholder="Nhập mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mã tài sản tại đơn vị:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.syncSourceId" placeholder="Nhập mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" v-if="increasementCauseTypes.length > 0">
                                <b-form-group label="Lý do tăng:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.increasementCauseId" :options="increasementCauseTypes" placeholder="--- Tất cả ---"
                                             allowClear="true"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" v-if="this.$route.meta.syncDataSource == 1">
                                <b-form-group label="Dự án:"
                                              label-for="project"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="project" v-model="searchForm.projectNameCode" placeholder="Nhập tên hoặc mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6"></b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <div class="form-group">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                    <b-button type="button" @click="exportExcel(0)" variant="primary" title="Xuất excel các trường hiển thị như grid">Xuất excel</b-button>
                                    <!--<b-button type="button" @click="exportExcel(1)" variant="primary" title="Xuất excel tất cả các trường">Xuất excel đầy đủ trường</b-button>-->
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :isRowSelectable="isDeletable"
                            dataUrl="data/assets"
                            gridName="Danh sách tài sản"
                            ref="assetsTable">
                        <!--<template v-slot:actions v-if="hasDeletePermission">
                            <b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>
                        </template>-->
                        <template v-slot:cell(assetTypeGroupId)="row">
                            {{ row.item.assetTypeGroupName }}
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.item.syncSourceType) }}
                        </template>
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(dateOfUse)="row">
                            {{ row.item.dateOfUse | formatDate }}
                        </template>
                        <template v-slot:cell(originalValue)="row">
                            {{ row.item.originalValue | currency }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['QLTSC_ViewAsset', 'CTNS_ViewAsset', 'HTGTDB_ViewAsset'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="isDeletable(row.item)" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                                <b-button v-if="authorize(['QLTSC_ViewAssetMutation', 'CTNS_ViewAssetMutation', 'HTGTDB_ViewAssetMutation'])" size="sm" @click.stop="mutation(row.item, row.index, $event.target)" class="mr-1" title="biến động" variant="success">
                                    Biến động
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'ListSyncedAssets',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    code: null,
                    syncSourceId: null,
                    syncStartDate: null, //new Date().firstDayOfMonth().formatDate(),
                    syncEndDate: new Date().formatDate(),
                    name: null,
                    assetTypeGroupId: null,
                    unitId: this.getUnitTreeIdCache(this.$route.meta.syncDataSource ?? this.getSyncSourceTypeCache()),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncSourceType: this.$route.meta.syncDataSource == 1 ? this.getSyncSourceTypeCache(null, null, [1, 2, 101, 102]) : (this.$route.meta.syncDataSource ?? this.getSyncSourceTypeCache()),
                    syncUnitType: 0,
                    projectNameCode: null,
                    assetTypeGroupRoot: this.$route.meta.assetTypeGroupRoot,
                    syncDataSource: this.$route.meta.syncDataSource,
                    increasementCauseId: null
                },
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã tài sản tại kho', sortable: true, sortDirection: 'asc' },
                        { key: 'syncSourceId', label: 'Mã tài sản tại đơn vị', sortable: true, sortDirection: 'asc' },
                        {
                            key: 'syncDate', label: 'Ngày đồng bộ', sortable: true, sortDirection: 'asc', groupable: true, groupFormatter: (value) => this.$options.filters.formatDate(value)
                        },
                        { key: 'name', label: 'Tên tài sản', sortable: true, sortDirection: 'asc' },
                        { key: 'assetTypeGroupId', label: 'Nhóm tài sản', sortable: true, sortDirection: 'asc', groupable: true, groupFormatter: (value, key, item) => item.assetTypeGroupName },
                        { key: 'assetTypeName', label: 'Loại tài sản', sortable: true, sortDirection: 'asc', groupable: true },
                        { key: 'unitName', label: 'Đơn vị quản lý', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }), groupable: true },
                        //{ key: 'unitTypeName', label: 'Loại đơn vị', sortable: true, sortDirection: 'asc', groupable: true },
                        { key: 'syncUnitName', label: 'Đơn vị đồng bộ', sortable: true, tdAttr: (key, value, item) => ({ title: item.syncUnitFullName }), groupable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true, sortDirection: 'asc', groupable: true, groupFormatter: (value, key, item) => this.$store.getters.getSyncSourceType(value) },
                        //{ key: 'dateOfUse', label: 'Ngày sử dụng', sortable: true },
                        { key: 'increasementCauseName', label: 'Lý do tăng', sortable: true },
                        { key: 'originalValue', label: 'Nguyên giá', sortable: true, tdClass: 'text-right' },
                        { key: this.$route.meta.syncDataSource == 1 ? 'projectName' : '', label: 'Tên dự án', sortable: true, sortDirection: 'asc' },
                        //this.$route.meta.syncDataSource == 1
                    ],
                    sortBy: 'assetTypeGroupId',
                    sortDesc: false
                },
                isShowBtnDelete: true,
                increasementCauseTypes: []
            }
        },
        computed: {
            ...mapState({
                listAssetTypes(state, getters) { return getters.assetTypeTree(null, this.searchForm.assetTypeGroupRoot) },
                //listAssetTypeGroups(state, getters) { return getters.assetTypeGroupTreeByRoot(this.searchForm.assetTypeGroupRoot) },
                listAssetTypeGroups: function (state, getters) {
                    if (this.selectedSyncSourceType) {
                        return state.common.assetTypeGroups.filter(x => x.parentId == this.selectedSyncSourceType.assetTypeGroupId).map(x => { return { id: x.id, text: x.name }; });
                    } else {
                        return state.common.assetTypeGroups.filter(x => x.parentId == this.searchForm.assetTypeGroupRoot).map(x => { return { id: x.id, text: x.name }; });
                    }
                },
                listSyncSourceTypes: function (state) {
                    if (this.searchForm.syncDataSource == 1) return state.common.listSyncSourceTypes.filter(x => x.syncDataSourceId == 1);
                    return state.common.listSyncSourceTypes;
                }
            }),
            selectedSyncSourceType() {
                return this.listSyncSourceTypes.find(x => x.id == this.searchForm.syncSourceType);
            },
            title() {
                return this.$route.meta.title;
                //var assetTypeGroup = this.$store.state.common.assetTypeGroups.find(x => x.id == this.searchForm.assetTypeGroupRoot);

                //return 'Danh sách ' + (assetTypeGroup ? assetTypeGroup.name : 'Tài sản').toLowerCase();
            },
            showAssetType() {
                //var groups = this.listAssetTypeGroups;

                //return groups.length == 1 && groups[0].children == null || groups[0].children.length == 0;
                return this.listAssetTypeGroups.length == 0;
            },
            hasDeletePermission() {
                var privileges = [];

                switch (this.searchForm.syncDataSource) {
                    case 1: privileges = ['QLTSC_ManageAsset']; break;
                    case 4: privileges = ['CTNS_ManageAsset']; break;
                    case 3: privileges = ['HTGTDB_ManageAsset']; break;

                    case 5: privileges = ['KCHTDS_ManageAsset']; break;
                    case 6: privileges = ['KCHTTL_ManageAsset']; break;
                    case 7: privileges = ['KCHTHK_ManageAsset']; break;
                    case 8: privileges = ['KCHTHH_ManageAsset']; break;
                    case 9: privileges = ['KCHTGTDTND_ManageAsset']; break;
                    case 10: privileges = ['KCHTK_ManageAsset']; break;

                    case 11: privileges = ['DATDAI_ManageAsset']; break;
                    case 12: privileges = ['TAINGUYEN_ManageAsset']; break;
                    case 13: privileges = ['TSCTDN_ManageAsset']; break;
                }

                return this.authorize(privileges);
            },
            unitSyncSourceType() {
                return this.searchForm.syncDataSource ?? this.searchForm.syncSourceType;
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId || 1;
            this.loadIncreasementCauses();
        },
        watch: {
            'searchForm.assetTypeGroupId': function () {
                this.loadIncreasementCauses();
            }
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.assetsTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            loadIncreasementCauses() {
                var vm = this;
                var assetTypeGroupId = this.searchForm.assetTypeGroupId ?? this.searchForm.assetTypeGroupRoot;
                if (assetTypeGroupId) {
                    this.$services.get(`lookup/increasement-causes?assetTypeGroupId=${assetTypeGroupId}`, null, { showLoading: false }).done(response => vm.increasementCauseTypes = response);
                } else {
                    this.increasementCauseTypes = this.$store.state.common.assetMutationCauses.filter(x => x.causeTypeId == 1 || x.causeTypeId == 7);
                }
            },
            search() {
                this.$refs.assetsTable.refresh();
            },
            isDeletable(row) {
                if (!row.canDelete) return false;

                var privileges = [];

                switch (this.searchForm.syncDataSource) {
                    case 1: privileges = ['QLTSC_ManageAsset']; break;
                    case 4: privileges = ['CTNS_ManageAsset']; break;
                    case 3: privileges = ['HTGTDB_ManageAsset']; break;
                }

                return this.authorize(privileges, row.syncUnitId);
            },
            mutation(item, index) {
                this.$router.push({
                    path: './asset-mutations/list',
                    query: { assetCode: `${item.code}`, unitOption: `${this.searchForm.unitTraversalOption}` }
                });
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa tài sản này?')) {
                    this.$services.delete(`data/assets/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa tài sản thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.assetsTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các tài sản này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/assets?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các tài sản thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn tài sản cần xóa');
                }
            },
            exportExcel(type) {
                //if (!this.searchForm.unitId) {
                //    this.searchForm.unitId = this.$store.state.identity.unitId;
                //}
                if (type == 0) {
                    this.$services.download2(`data/asset/export`, this.searchForm);
                }
                else {
                    this.$services.download2(`data/asset/export-all-fields`, this.searchForm);
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
